import React, { useEffect } from 'react'
import Housestyle from '../assets/house-style.png'
import Pricerange from '../assets/price-range.png'
import Minibedicon from '../assets/mini-bed-icon.png'
import Bathicon from '../assets/bath-icon.png'
import Houseareaicon from '../assets/house-area-icon.png'
import { useProperty } from '../context/PropertyContext.js'
import Spinner from './Spinner.js'
import { Link } from 'react-router-dom'
import { useState } from 'react'
import Pagination from './Pagination.js'

const serverUrlImage = 'https://osdevhub.com/projects/homify/uploads';


function formatWithComma(price) {
    return parseInt(price).toLocaleString('en-US');
}


function DashboardHomeProperties() {
    const {allPropertyData, fetchAllPropertiesPaginate, totalPages:allPages, propertyIsLoading} = useProperty();

    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(allPages || 1);
    const [priceRange, setPriceRange] = useState('');
    const [propertyType, setPropertyType] = useState('');
    const [showPriceDropdown, setShowPriceDropdown] = useState(false);
    const [showHouseFilterDropdown, setShowHouseFilterDropdown] = useState(false);
    const limit =  9;



useEffect(() => {
    const fetchData = async () => {
        let data = {
            page: currentPage,
            limit: limit,
            search: searchTerm,
            priceRange: priceRange,
            propertyType: propertyType
        };
        await fetchAllPropertiesPaginate(data);
    };
    
    fetchData();
}, [currentPage, searchTerm, priceRange, fetchAllPropertiesPaginate, propertyType]);


    useEffect(() => {
        if(allPages){
            setTotalPages(allPages)
        }
    }, [allPages]);

      const handlePriceRangeSelect = (range) => {
        setPriceRange(range);
        setCurrentPage(1); 
        setShowPriceDropdown(false); 
        setPropertyType('')
    }

      const handlePropertyTypeSelect = (type) => {
        setPropertyType(type);
        setCurrentPage(1); 
        setShowHouseFilterDropdown(false); 
          setPriceRange('');
    }



        const handlePageChange =  async(page) => {
       
        if (page >= 1 && page <= totalPages) {
            
                setCurrentPage(page)
          
            
            
       
            let data = {
                page: page,
                limit: limit,
                search: searchTerm,
                priceRange: priceRange,
                propertyType: propertyType
            }
                 await fetchAllPropertiesPaginate(data)
         
        }
         
    }

 
  return (
    <div className="homify-recommendation margin-top2 dashcontainer-child " id="recommendation">
     
            <h2 className='recommendation-container-h2'>Property Recommendations for You</h2>
            <div className="recommendation-searchcontaiiner">
                <div className="recommendation-search">
                    <input 
                        type="text" 
                        placeholder="search name, location, description" 
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1);  // Reset to first page on new search
                        }}
                    />
                    <button type="button" onClick={() => setCurrentPage(1)}>Search</button>
                </div>

                <div className="recommendation-filter">
                    <div className='house-filter-container'>
                        <div className="house-filter" onClick={() => setShowHouseFilterDropdown(!showHouseFilterDropdown)}>
                            <img src={Housestyle} alt="house-icon" />
                            <p>Property Type</p>
                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.24995 3.90002L6.49995 7.15002L9.74995 3.90002L11.05 4.55002L6.49995 9.10002L1.94995 4.55002L3.24995 3.90002Z" fill="#00985B"/>
                            </svg>
                        </div>
                        {showHouseFilterDropdown && (
                            <div className="house-filter-dropdown">
                                <button className='price-button' onClick={() => handlePropertyTypeSelect("Residential Building")}>Residential Building</button>
                                <button className='price-button' onClick={() => handlePropertyTypeSelect("Commercial Building")}>Commercial Building</button>
                                <button className='price-button' onClick={() => handlePropertyTypeSelect("Land")}>Land</button>
                       
                            </div>
                        )}
                    </div>
                    
                    <div>
                        <div className='price-container'>
                            <div className="house-filter" onClick={() => setShowPriceDropdown(!showPriceDropdown)}>
                                <img src={Pricerange} alt="house-icon" />
                                <p>Price Range</p>
                                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.24995 3.90002L6.49995 7.15002L9.74995 3.90002L11.05 4.55002L6.49995 9.10002L1.94995 4.55002L3.24995 3.90002Z" fill="#00985B"/>
                                </svg>   
                        
                            </div>
                            {showPriceDropdown && (
                                    <div className="price-dropdown">
                                        <button className='price-button' onClick={() => handlePriceRangeSelect("0-20000000")}>₦0 - ₦20,000,000</button>
                                        <button className='price-button' onClick={() => handlePriceRangeSelect("20000000-50000000")}>₦20,000,000 - ₦50,000,000</button>
                                        <button className='price-button' onClick={() => handlePriceRangeSelect("50000000-100000000")}>₦50,000,000 - ₦100,000,000</button>
                                        <button className='price-button' onClick={() => handlePriceRangeSelect("100000000-1000000000")}>₦100,000,000 - ₦1,000,000,000</button>
                                    </div>
                            )}
                        </div>
                    </div>
      
           
                </div>
            </div>
            
            <div className="recommendation-cardcontainer">
 

                {
                    propertyIsLoading ? (
                        <p style={{color:'#000'}}>Loading...</p>
                    ) : (
                        allPropertyData && allPropertyData.length !== 0 ? (
                           allPropertyData.filter(property => property.status === 'true').map((property, index) => {
                        return <DashboardPropertyCard key={index} property={property} />;
                        })
                        ) : (
                            <p style={{color: '#000'}}>No properties found.</p>
                        )
                    )
                }
            </div>
            

     
                 <Pagination
                currentPage={currentPage} 
                totalPages={totalPages} 
                onPageChange={handlePageChange} 
            />
    </div>
  )
}


function DashboardPropertyCard({property}){
   return    (

    <Link to= {`${property.id}?user_id=${property.user_id}`}>
         <div className="recommendation-card">
            <img src={`${serverUrlImage}/${property.image}`} alt={property.name} />
            <div  className="recommendation-carddetails">
                <h4>N{formatWithComma(property.price)}</h4>
                <p><strong>Name:</strong> {property.name_of_property}</p>
                <p><strong>Location:</strong> {property.address}</p>
                <p><strong>Transaction:</strong> {property.transaction}</p>
                <p><strong>Property Type:</strong> {property.type_of_property}</p>
                <p><strong>Availability:</strong> Still available</p>
            </div>
            <div className="inner-carddetails">
                <div className="innerdetails-content">
                    <div className="innerdetails-image">
                        <img src={Minibedicon} alt="" />
                        <p>{property.no_bedroom}</p>
                    </div>
                    <p>Bedroom</p>
                </div>
                <div className="innerdetails-content">
                    <div className="innerdetails-image">
                        <img src={Bathicon} alt="" />
                        <p>{property.no_bathroom}</p>
                    </div>
                    <p>Bathroom</p>
                </div>
                <div className="innerdetails-content">
                    <div className="innerdetails-image">
                        <img src={Houseareaicon} alt="" />
                        <p>{formatWithComma(property.house_area)}m</p>
                    </div>
                    <p>House Area</p>
                </div>
            </div>
                <div>
                    <p className='description-text'><strong className='description-text'>Description:</strong> {property.description}</p>
                </div>
            <div className="inner-carddetails">
                <div className="innerdetails-content">
                    <div className="innerdetails-image">
                        <p>Posted By: {property.user_name}</p>
                    </div>
             
                </div>
            
                
            
            </div>

            <div className="innerdetails-image">
                <p>Status: {property.status === 'true' ? 'Approved' : 'Not Approved'}</p>
            </div>


        </div>
    </Link>
  
            
        
        )
}

export default DashboardHomeProperties